// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpErrorUploadDesign_closeButton__CrTQ0","rounded":"PopUpErrorUploadDesign_rounded__1xxnl"};